import React from 'react';

import { extractVideoInfo } from './videoInfo';

const getEmbedLink = (input) => {
  if (!input) return null;

  const videoInfo = extractVideoInfo(input);

  if (videoInfo === null) return null;

  if (videoInfo.platform === 'youtube') {
    return `https://www.youtube.com/embed/${videoInfo.id}`;
  }

  if (videoInfo.platform === 'vimeo') {
    return `https://player.vimeo.com/video/${videoInfo.id}`;
  }

  return null;
};

const VideoPreview = ({ input }) => {
  const embedUrl = getEmbedLink(input);

  if (!embedUrl) return null;

  return (
    <div className='video__preview'>
      <iframe
        className='video__iframe'
        src={embedUrl}
        allowFullScreen
      />
    </div>
  );
};

export default VideoPreview;
